export const MAIN_PAGE = '/page/main';
export const MAIN_PAGE_MEDIA = '/carousel';
export const PROCESS_PAGE = '/page/process';

export const PORTFOLIO = '/portfolio';
export const PORTFOLIO_DETAILS = '/portfolio/:id';

export const RESOURCES = '/resource';
export const RESOURCE_DETAILS = '/resource/:id';

export const CAREER = '/career';
export const CAREER_DETAILS = '/career/:id';
export const CAREER_SUBMIT_CV = '/career/send-cv';

export const EMPLOYEES = '/employee';
export const EMPLOYEE_DETAILS = '/employee/:id';

export const EXPERTISE = '/expertise';
export const EXPERTISE_INTERACT = '/expertise/interact';
export const EXPERTISE_UX = '/expertise/ux';
export const EXPERTISE_DESIGN_REVIEW = '/expertise/design-review';
export const EXPERTISE_AI = '/expertise/ai';
export const EXPERTISE_UI = '/expertise/ui';
export const EXPERTISE_GRAPHIC_DESIGN = '/expertise/graphic-design';

export const CONTACT_US = '/contact-us';



// WEBPACK FOOTER //
// ./src/config/routes.js